import { ExtraDataApiModel, HotelRoomApiModel } from '@rocksoft/inroom-sdk';

import { Action } from '@ngrx/store';

export enum RoomActionTypes {
  ROOM_API_ROOMS_LOADED = '[Room API] Rooms Loaded',
  ROOM_API_ROOM_LOADED = '[Room API] Room Loaded',
  ROOM_API_ROOM_ADDED = '[Room API] Room Added',
  ROOM_API_ROOM_DELETED = '[Room API] Room Deleted',

  ROOM_HEADER_ROOM_DELETED = '[Room Header] Room Deleted',
  ROOM_STATUS_ROOM_CHECKED_IN = '[Room Status] Room Checked In',
  ROOM_STATUS_ROOM_CHECKED_OUT = '[Room Status] Room Checked Out',

  ROOM_RESOLVER_ROOM_SELECTED = '[Room Resolver] Room Selected',

  ROOM_SIGNALR_STATE_CHANGE = '[Room SignalR] Room State Changed',
  ROOM_ADD_MODAL_CONFIRMED = '[Room Add Modal] Add Confirmed',
  ROOM_GUEST_MODAL_OPENED = '[Room Guest Modal] Modal Opened',

  ROOM_EXTRA_DATA_UPDATED = '[Guest Status] Extra Data Updated',
  ROOM_EXTRA_DATA_UPDATED_API = '[Room Effects] Extra Data Updated',
  ROOM_EXTRA_DATA_UPDATED_API_FAILED = '[Room Effects] Extra Data Update Failed',

  ROOM_EFFECT_NAVIGATED_BACK = '[Room Effect] Navigated Back',
}

export class RoomApiRoomsLoaded implements Action {
  readonly type = RoomActionTypes.ROOM_API_ROOMS_LOADED;

  constructor(public payload: HotelRoomApiModel[]) {}
}

export class RoomApiRoomLoaded implements Action {
  readonly type = RoomActionTypes.ROOM_API_ROOM_LOADED;

  constructor(public payload: { id: string; changes: HotelRoomApiModel }) {}
}

export class RoomAddModalConfirmed implements Action {
  readonly type = RoomActionTypes.ROOM_ADD_MODAL_CONFIRMED;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomApiRoomAdded implements Action {
  readonly type = RoomActionTypes.ROOM_API_ROOM_ADDED;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomApiRoomDeleted implements Action {
  readonly type = RoomActionTypes.ROOM_API_ROOM_DELETED;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomHeaderRoomDeleted implements Action {
  readonly type = RoomActionTypes.ROOM_HEADER_ROOM_DELETED;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomResolverRoomSelected implements Action {
  readonly type = RoomActionTypes.ROOM_RESOLVER_ROOM_SELECTED;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomSignalRStateChange implements Action {
  readonly type = RoomActionTypes.ROOM_SIGNALR_STATE_CHANGE;

  constructor(public payload: { id: string; changes: HotelRoomApiModel }) {}
}

export class RoomStatusRoomCheckedIn implements Action {
  readonly type = RoomActionTypes.ROOM_STATUS_ROOM_CHECKED_IN;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomStatusRoomCheckedOut implements Action {
  readonly type = RoomActionTypes.ROOM_STATUS_ROOM_CHECKED_OUT;

  constructor(public payload: HotelRoomApiModel) {}
}

export class RoomGuestModalOpened implements Action {
  readonly type = RoomActionTypes.ROOM_GUEST_MODAL_OPENED;
}

export class RoomEffectNavigatedBack implements Action {
  readonly type = RoomActionTypes.ROOM_EFFECT_NAVIGATED_BACK;
}

export class RoomExtraDataUpdated implements Action {
  readonly type = RoomActionTypes.ROOM_EXTRA_DATA_UPDATED;

  constructor(public payload: { hotelCode: string; unitCode: string; data: ExtraDataApiModel }) {}
}

export class RoomExtraDataUpdatedApi implements Action {
  readonly type = RoomActionTypes.ROOM_EXTRA_DATA_UPDATED_API;

  constructor(public payload: { hotelCode: string; unitCode: string; data: ExtraDataApiModel }) {}
}

export class RoomExtraDataUpdatedApiFailed implements Action {
  readonly type = RoomActionTypes.ROOM_EXTRA_DATA_UPDATED_API_FAILED;
}

export type RoomActionsUnion =
  | RoomApiRoomsLoaded
  | RoomApiRoomLoaded
  | RoomAddModalConfirmed
  | RoomHeaderRoomDeleted
  | RoomResolverRoomSelected
  | RoomApiRoomAdded
  | RoomApiRoomDeleted
  | RoomSignalRStateChange
  | RoomStatusRoomCheckedIn
  | RoomStatusRoomCheckedOut
  | RoomGuestModalOpened
  | RoomEffectNavigatedBack
  | RoomExtraDataUpdated
  | RoomExtraDataUpdatedApi
  | RoomExtraDataUpdatedApiFailed;
